import AboutPage from 'src/pages/aboutPage';
import ContactPage from 'src/pages/contactPage';
import LandingPage from 'src/pages/landingPage/landingPage';
import { Routes } from 'src/utils/enums';
import SelectedService from 'src/pages/services/selectedService';
import ServicesPage from 'src/pages/services/servicesPage';
import { createBrowserRouter } from 'react-router-dom';
import { servicesData } from 'src/resources/data/landingPageData';

export const router = createBrowserRouter([
    {
        element: <LandingPage />,
        path: Routes.LANDING_PAGE,
    },
    {
        element: <AboutPage/>,
        path: Routes.ABOUT_PAGE
    },
    /**  {
         element: <BlogPage/>,
         path: Routes.BLOG_PAGE
     }, */
    {
        element: <ContactPage/>,
        path: Routes.CONTACT_PAGE
    },
    {
        element: <ServicesPage/>,
        path: Routes.SERVICES_PAGE
    },
    ...servicesData(false).map((service) => ({
        element: <SelectedService service={service}/>,
        path: service.link,
    }))
]);
